export default function getAiKeysFromType(type) {
  const typeFieldKey = type === 'query_rewriter' ? 'rewriter_type' : 'enricher_type';

  const typePropFieldKey = type === 'query_rewriter' ? 'rewriter.type' : 'enricher.type';

  const codeFieldKey = type === 'query_rewriter' ? 'rewriter_code' : 'enricher_code';

  const nameFieldKey = type === 'query_rewriter' ? 'rewriter_name' : 'enricher_name';

  const promptVar = type === 'query_rewriter' ? 'custom_query_rewriter' : 'custom_context_enricher';

  return {
    typeFieldKey,
    typePropFieldKey,
    codeFieldKey,
    nameFieldKey,
    promptVar,
  };
}
